import { Input } from '@/components/common/Input';
import { Select } from '@/components/common/Select';
import type { BeddingAreaMetadata } from '@/types/waypoint';

interface BeddingAreaFormProps {
  metadata: Partial<BeddingAreaMetadata>;
  onChange: (updated: Partial<BeddingAreaMetadata>) => void;
}

const BEDDING_TYPE_OPTIONS = [
  { value: 'natural', label: 'Natural' },
  { value: 'created_hinge_cut', label: 'Hinge Cut' },
  { value: 'created_screen', label: 'Screen Planting' },
  { value: 'other', label: 'Other' },
];

const COVER_DENSITY_OPTIONS = [
  { value: 'light', label: 'Light' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'heavy', label: 'Heavy' },
];

export function BeddingAreaForm({ metadata, onChange }: BeddingAreaFormProps) {
  return (
    <div className="flex flex-col gap-4">
      <Select
        id="bedding-type"
        label="Bedding Type"
        value={metadata.beddingType ?? 'natural'}
        onChange={(v) =>
          onChange({ ...metadata, beddingType: v as BeddingAreaMetadata['beddingType'] })
        }
        options={BEDDING_TYPE_OPTIONS}
      />

      <Select
        id="cover-density"
        label="Cover Density"
        value={metadata.coverDensity ?? 'moderate'}
        onChange={(v) =>
          onChange({ ...metadata, coverDensity: v as BeddingAreaMetadata['coverDensity'] })
        }
        options={COVER_DENSITY_OPTIONS}
      />

      <Input
        id="bedding-primary-species"
        label="Primary Species Using Area"
        value={metadata.primarySpeciesUsing ?? ''}
        onChange={(v) => onChange({ ...metadata, primarySpeciesUsing: v || undefined })}
        placeholder="e.g. whitetail, turkey"
      />
    </div>
  );
}
